import React from 'react'
import { RounderUtil } from 'utils'

import { Col, Form } from '_zari/core'

const ImporteIgvFormGroup = ({ vTotal, setFieldValue, iValue, handleChange }) => {

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      const valorStr = e.target.value
      const valorNumero = parseFloat(valorStr || '0')

      const total = RounderUtil.round(vTotal - iValue + valorNumero)
      setFieldValue('importeTotal', total)
    },
    [setFieldValue, vTotal, handleChange, iValue]
  )

  return (
    <Form.Group>
      <Form.Label text='IGV' htmlFor='input-importeIgv' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber id='input-importeIgv' name='importeIgv' value={iValue} onChange={onChange} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteIgvFormGroup)
